import http from '../axios';

export function login(payload) {
  return http.post('/sessions/create', payload);
}

export function logout() {
  return http.delete('/sessions/destroy');
}